import React from "react";
import PropTypes from "prop-types";

import {
  CardBox,
  DetailsPanel,
  ImageContainer,
  DescriptionText
} from "../CardsStyled";
import { useTranslate } from "hooks/translation-hooks";
import PictureBox from "./PictureBox";

const pictureUploadedCategory = "take_photos_incident";
const pictureUploadedTestId = "photos_uploaded_card-displayed";

export const PicturesUploaded = ({ pictures, isCurrent }) => {
  const t = useTranslate();
  return (
    <CardBox
      data-category={pictureUploadedCategory}
      data-testid={pictureUploadedTestId}
    >
      <DetailsPanel>
        <DescriptionText>
          {`${t("history_photos_card-text_1")} ${pictures.length} ${t(
            "history_photos_card-text_2"
          )}`}
        </DescriptionText>
        <ImageContainer>
          {pictures.map((picture, indexLink) => (
            <PictureBox
              picture={picture}
              indexLink={indexLink}
              key={indexLink}
            />
          ))}
        </ImageContainer>
      </DetailsPanel>
    </CardBox>
  );
};

PicturesUploaded.propTypes = {
  pictures: PropTypes.arrayOf(
    PropTypes.shape({
      file_name: PropTypes.string,
      file_extension: PropTypes.string,
      file_binary: PropTypes.string
    })
  ),
  isCurrent: PropTypes.bool
};

PicturesUploaded.defaultProps = {
  pictures: [],
  isCurrent: false
};

export default PicturesUploaded;
